import { apiSlice } from '@src/services/api/apiSlice';
import { Role } from '../roleTypes';
import { AddRoleParams } from './addRoleApiSliceTypes';

const addRoleApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        addRole: builder.mutation<Role, AddRoleParams>({
            query: (params) => ({
                url: `/roles`,
                method: 'POST',
                body: { ...params },
            }),
            invalidatesTags: [{ type: 'roles', id: 'LIST' }],
        }),
    }),
    overrideExisting: true,
});

export const { useAddRoleMutation } = addRoleApiSlice;
